import { toast as sonnerToast, type ExternalToast } from "sonner"

export type ToastOptions = ExternalToast

/**
 * Utilitário de Notificações Toast no padrão shadcn/ui (sonner)
 */
export const toast = {
  /** Notificação de Sucesso (Verde) */
  success: (title: string, options?: ToastOptions | string) => {
    const opts = typeof options === "string" ? { description: options } : options
    return sonnerToast.success(title, opts)
  },

  /** Notificação Informativa (Azul) */
  info: (title: string, options?: ToastOptions | string) => {
    const opts = typeof options === "string" ? { description: options } : options
    return sonnerToast.info(title, opts)
  },

  /** Notificação de Alerta/Aviso (Amarelo/Laranja) */
  warning: (title: string, options?: ToastOptions | string) => {
    const opts = typeof options === "string" ? { description: options } : options
    return sonnerToast.warning(title, opts)
  },

  /** Notificação de Erro (Vermelho) */
  error: (title: string, options?: ToastOptions | string) => {
    const opts = typeof options === "string" ? { description: options } : options
    return sonnerToast.error(title, opts)
  },

  /** Notificação de Carregamento (Spinner com ID retornado) */
  loading: (title: string, options?: ToastOptions | string) => {
    const opts = typeof options === "string" ? { description: options } : options
    return sonnerToast.loading(title, opts)
  },

  /** Notificação vinculada a uma Promise com transição automática */
  promise: <T>(
    promise: Promise<T>,
    messages: {
      loading: string
      success: string | ((data: T) => string)
      error: string | ((error: any) => string)
    }
  ) => {
    return sonnerToast.promise(promise, messages)
  },

  /** Dispensar Notificação */
  dismiss: (id?: string | number) => sonnerToast.dismiss(id),

  /** Personalizada */
  custom: sonnerToast.custom,
}
